// extracted by mini-css-extract-plugin
export default {"cleanTimerControls":"CleanTimerControls_cleanTimerControls__3qbOh","startTimerIcon":"CleanTimerControls_startTimerIcon__MZd6g"};